'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'face-smile';
var width = 512;
var height = 512;
var aliases = [128578,"smile"];
var unicode = 'f118';
var svgPathData = ['M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm121.4 76.6l13.1-9.2C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6l13.1 9.2C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4zM192.4 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm160 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm137.4 76.6l13.1-9.2C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6l13.1 9.2C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceSmile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;